export default {"src":"/_next/static/media/1.9a1c9da1.svg","height":140,"width":127,"blurWidth":0,"blurHeight":0};